export default __webpack_public_path__ + "static/media/3stepweightloss_2.5525c8d8.jpg";